export default __webpack_public_path__ + "static/media/logoicon-top.7120d8c4.png";